import React from 'react';

var Account = function Account(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 15c-3.632 0-7 1.894-7 4h14c0-2.106-3.368-4-7-4zm0-2c3.755 0 9 2.01 9 6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2c0-3.99 5.245-6 9-6zm0-4a1.999 1.999 0 1 0 0-4 1.999 1.999 0 1 0 0 4zm0 2c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Account.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Account as icon };
export default iconHandler(Account);